import $ from 'jquery';
import manageRefineMenu from '../entry-points/plp/manage-refine-menu';
import 'styleguide/modules/product-filter-active-button';
import 'styleguide/modules/product-filter-search';
import 'styleguide/modules/product-filter-count';
import 'styleguide/modules/product-filter-clear-all';
import { SIDE_PANEL_HTML_ID } from "../../../styleguide/src/assets/modules/side-panel";

const SELECTOR = '.js-side-panel-sort-filter';

// "init" at the start of the function is preferred but leaving at the end of the filename for organization purposes
export const initSidePanel = () => {
    const sidePanelHref = window.rcProps.sidebarHref ? window.rcProps.sidebarHref : window.rcProps.search.sidebarHref;
    if (sidePanelHref) {
        const hrefEncoded = encodeURIComponent(window.location.href);
        $(SELECTOR).sidePanel({
            url: `${sidePanelHref}?url=${hrefEncoded}`,
            onAjaxLoad: () => {
                $('.js-accordion-side-nav').accordion({
                    onLoad: () => {
                        $('.side-panel__panel').animate({
                            scrollTop: 0
                        }, 200);
                    }
                })
                manageRefineMenu();
                $('.js-product-filter-clear-all').productFilterClearAll();
                $('.js-product-filter-search').productFilterSearch();
                $('.js-product-filter-active-button').productFilterActiveButton();
                $('.js-product-filter-count').productFilterCount();

                $('#side-panel__overlay, #done_filters').on('click', function () {
                    if ($('.js-product-filter-clear-all').length) {
                        $('.js-accordion-side-nav').accordion('closeAll');
                    }
                })
            },
            returnFocus: '#sortRefineBtn',
        });

        $(SELECTOR).on('click', function () {
            logEngagement(window.location.href, 'Filter & Sort Side Panel', 'Click');
        });
        return true;
    } else {
        return false;
    }
};

export const resetSidePanel = () => {
    $(SELECTOR).off('click').removeData('sidePanel');
    $(`#${SIDE_PANEL_HTML_ID}`).remove();
    initSidePanel();
}
export default initSidePanel;


// WEBPACK FOOTER //
// ./src/scripts/modules/side-panel-init.js